module.exports = __webpack_public_path__ + "img/device-state-indicator-green.9f94ecd2.svg";